/**
 * Route guards. Thin wrappers that read the auth store. The server is the
 * authoritative enforcer; these are for UX (redirect unauthenticated users).
 */

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/store/auth";

export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useAuth((s) => s.status);
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm">
        Loading…
      </div>
    );
  }
  if (status !== "authenticated") {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}

export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const role = useAuth((s) => s.user?.role);
  if (role !== "super_admin") {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
